import React from 'react';
import ReactDOM from 'react-dom';
// import InputRange from 'react-input-range';

class MapRadius extends React.Component {
  constructor(props) {
    super(props);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.initRange = this.initRange.bind(this);
  }
  componentDidMount() {
    this.initRange(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.slider.update({
      from: nextProps.values.min,
    });
  }

  getHistogram(countEachMetaDataValue) {
    const bars = countEachMetaDataValue.map((item, index) => {
      const className = 'bar-chart__bar';
      return (
        <div className={className}
          key={'mapradius-' + index}
          style={
            { height: item * 3 }
          }
        >
        </div>
      );
    });
    return (
      <div className="bar-chart">
        {bars}
      </div>
    );
  }

  initRange(props) {
    const self = this;
    const target = ReactDOM.findDOMNode(this);
    jQuery(target).ionRangeSlider({
      type: 'single',
      grid: true,
      min: Number(props.minvalue),
      max: Number(props.maxvalue),
      from: Number(props.values.min),
      prefix: props.unit ? props.unit + ' ' : '',
      onFinish: self.handleValueChange,
    });
    this.slider = jQuery(target).data('ionRangeSlider');
  }
  handleValueChange(val) {
    this.props.grabRangeSelectValue(val.from);
  }
  render() {
    return (
        <input type="text" id="rangeInput" name="example_name" value="" />
    );
  }
}
MapRadius.propTypes = {
  'maxvalue': React.PropTypes.number,
  'minvalue': React.PropTypes.number,
  'values': React.PropTypes.object,
  'options': React.PropTypes.array,
  'grabRangeSelectValue': React.PropTypes.func,
};
export default MapRadius;



// WEBPACK FOOTER //
// ./assets/src/frontend/element/mapRadius.js